import React from "react";

const Disclaimer = ({ darkTheme }) => {
  return (
    <div
      id="disclaimer"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Cr&eacute;dits
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <p>
              Ce portfolio a été conçu et développé par <strong>Osama Khait</strong>.
              Voici les technologies et ressources utilisées pour sa réalisation.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Technologies utilisées
            </h5>
            <ul className="lh-lg">
              <li>
                <strong>React.js</strong> – Bibliothèque JavaScript pour la construction de l'interface utilisateur.
              </li>
              <li>
                <strong>Bootstrap 5</strong> – Framework CSS pour le design responsive.
              </li>
              <li>
                <strong>SASS/SCSS</strong> – Préprocesseur CSS pour la gestion des styles.
              </li>
              <li>
                <strong>AOS (Animate On Scroll)</strong> – Animations au défilement.
              </li>
              <li>
                <strong>tsParticles</strong> – Effet de particules animées interactives.
              </li>
              <li>
                <strong>Typewriter Effect</strong> – Animation de texte dans la section d'accueil.
              </li>
              <li>
                <strong>EmailJS</strong> – Service d'envoi d'emails via le formulaire de contact.
              </li>
            </ul>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Hébergement &amp; outils
            </h5>
            <ul className="lh-lg">
              <li>
                Code source hébergé sur <strong>GitHub</strong>.
              </li>
              <li>
                Icônes fournies par <strong>Font Awesome</strong>.
              </li>
            </ul>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Droits d'auteur
            </h5>
            <p>
              &copy; 2026 Osama Khait. Tous droits réservés. Le contenu de ce site
              (textes, images, code) est la propriété de son auteur. Toute reproduction
              sans autorisation est interdite.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
